import { SuiteManifest } from '../manifest';
import { coreRoutes } from './routes';

export const coreSuite: SuiteManifest = {
  id: 'core',
  code: 'S0_CORE',
  name: 'Core Institute Suite',
  basePath: '/core',
  icon: 'layout-dashboard',
  description: 'Foundational operating suite for classes, members, study notes, fee records, and noticeboard',
  nav: [
    {
      label: 'Institute Cockpit',
      path: '/core/dashboard',
      icon: 'layout-dashboard',
      group: 'Overview',
      moduleId: 'dashboard',
      permission: 'core.dashboard.read',
    },
    {
      label: 'Member Directory',
      path: '/core/directory',
      icon: 'users',
      group: 'Administration',
      moduleId: 'directory',
      permission: 'core.directory.read',
      allowedRoles: ['owner', 'admin', 'branch_head', 'teacher', 'counselor', 'accountant'],
    },
    {
      label: 'Inquiries & Leads',
      path: '/core/inquiries',
      icon: 'user-plus',
      group: 'Administration',
      moduleId: 'inquiries',
      permission: 'core.inquiries.read',
      allowedRoles: ['owner', 'admin', 'branch_head', 'counselor'],
    },
    {
      label: 'Batches & Schedule',
      path: '/core/batches',
      icon: 'calendar',
      group: 'Administration',
      moduleId: 'batches',
      permission: 'core.batches.read',
    },
    {
      label: 'Batch Attendance',
      path: '/core/attendance',
      icon: 'calendar-check',
      group: 'Academics',
      moduleId: 'attendance',
      permission: 'core.attendance.read',
      allowedRoles: ['owner', 'admin', 'branch_head', 'teacher', 'counselor', 'accountant', 'student', 'parent'],
    },
    {
      label: 'Study Notes & Handouts',
      path: '/core/study',
      icon: 'book-open',
      group: 'Academics',
      moduleId: 'study',
      permission: 'core.study.read',
    },
    {
      label: 'Fee Record Book',
      path: '/core/fee-book',
      icon: 'receipt',
      group: 'Finance',
      moduleId: 'fee-book',
      permission: 'core.feebook.read',
      allowedRoles: ['owner', 'admin', 'branch_head', 'counselor', 'accountant', 'student', 'parent'],
    },
    {
      label: 'Noticeboard',
      path: '/core/noticeboard',
      icon: 'bell',
      group: 'Communication',
      moduleId: 'noticeboard',
      permission: 'core.notices.read',
    },
  ],
  routes: coreRoutes,
};
